<template>
    <div class="slide-renderer" :class="`slide-renderer--${slide.tipo}`">
        <template v-if="slide.tipo === 'capa'">
            <div class="slide-capa">
                <h1 class="slide-capa-titulo">{{ slide.titulo || 'Revisão Executiva de Prioridades' }}</h1>
                <p v-if="slide.subtituloExibido || slide.subtitulo" class="slide-capa-subtitulo">
                    {{ slide.subtituloExibido || slide.subtitulo }}
                </p>
            </div>
        </template>

        <template v-else>
            <h2 v-if="slide.titulo" class="slide-titulo">{{ slide.titulo }}</h2>
            <p
                v-if="slide.tipo === 'tabela' && slide.fonte === 'dinamica' && slide.fonteDadosLabel"
                class="slide-fonte-badge"
            >
                Dados do painel: {{ slide.fonteDadosLabel }}
                <span class="slide-fonte-contagem">({{ slide.linhas?.length || 0 }} registros)</span>
            </p>

            <ul v-if="slide.tipo === 'texto'" class="slide-texto-lista">
                <li v-for="(b, i) in slide.bullets" :key="i">{{ b }}</li>
                <li v-if="!slide.bullets?.length" class="slide-vazio-item">(sem conteúdo)</li>
            </ul>

            <TabelaSlideApresentacao
                v-else-if="slide.tipo === 'tabela'"
                :colunas="slide.colunas || []"
                :linhas="slide.linhas || []"
            />

            <SlideImagemApresentacao
                v-else-if="slide.tipo === 'imagem'"
                :imagem-data-url="slide.imagemDataUrl"
                :legenda="slide.imagemLegenda"
                :titulo="slide.titulo"
                :ajuste="slide.imagemAjuste || 'contain'"
            />
        </template>
    </div>
</template>

<script>
import TabelaSlideApresentacao from './TabelaSlideApresentacao.vue'
import SlideImagemApresentacao from './SlideImagemApresentacao.vue'

export default {
    name: 'SlideApresentacaoRenderer',

    components: {
        TabelaSlideApresentacao,
        SlideImagemApresentacao,
    },

    props: {
        slide: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style scoped>
.slide-renderer {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    height: 100%;
    min-height: 0;
}

.slide-renderer--capa {
    justify-content: center;
    align-items: center;
    text-align: center;
}

.slide-capa-titulo {
    margin: 0;
    font-size: clamp(1.75rem, 4vw, 2.75rem);
    font-weight: 700;
    color: var(--cor-primaria-forte, #008a88);
    line-height: 1.2;
}

.slide-capa-subtitulo {
    margin: 1rem 0 0;
    font-size: clamp(1rem, 2.5vw, 1.35rem);
    color: #444;
}

.slide-titulo {
    margin: 0;
    font-size: clamp(1.25rem, 3vw, 2rem);
    font-weight: 700;
    color: var(--cor-primaria-forte, #008a88);
    flex-shrink: 0;
}

.slide-fonte-badge {
    margin: -0.35rem 0 0;
    font-size: clamp(0.8rem, 1.6vw, 0.95rem);
    color: #555;
    flex-shrink: 0;
}

.slide-fonte-contagem {
    color: #777;
}

.slide-texto-lista {
    margin: 0;
    padding-left: 1.5rem;
    font-size: clamp(0.95rem, 2vw, 1.15rem);
    line-height: 1.55;
}

.slide-vazio-item {
    list-style: none;
    margin-left: -1.5rem;
    color: #888;
    font-style: italic;
}

.slide-renderer--texto,
.slide-renderer--tabela,
.slide-renderer--imagem {
    min-height: 0;
}

.slide-renderer--tabela,
.slide-renderer--imagem {
    flex: 1;
    overflow: hidden;
}
</style>
